export default __webpack_public_path__ + "static/media/avatar-normal-geometric-15.99c3b64a.svg";